const $ = require('jquery')
const Vue = require('vue')

Vue.component('form-colorpicker', {
    props: {
        label: {
            twoWay: true,
            type: String
        },
        model: {
            twoWay: true,
            default: false
        },
        compact: {
            default: false
        },
        onChange: {
            type: Function,
            default: () => {
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            fieldName: ''
        }
    },
    ready () {
        this.fieldName = this._props.model.raw

        this.render()
    },
    methods: {
        changed (evt) {
            if (this.onChange) {
                this.onChange(evt.target.checked)
            }
        },
        render () {
            const $self = $(this.$els.input)

            $self
                .unbind()
                .colorpicker({
                    format: 'hex'
                })
                .on('changeColor', (a, b, c) => {
                    if (a.value) {
                        this.model = a.value
                    }
                })
        }
    },
    watch: {
        disabled () {
            this.render()
        },
        model () {

        },
        label () {
            this.render()
        }
    },
    template: `
            <div class="form-group">
                <label v-if="label">{{ label }}</label>
                <div class="input-group colorpicker-component" v-el:component>
                    <input v-el:input
                           type="text"
                           class="form-control"
                           v-bind:placeholder="placeholder"
                           v-model="model"
                           v-on:click=""
                           v-bind:data-field="fieldName"
                           v-bind:disabled="disabled">
                           <span class="input-group-addon">
                            <i v-bind:style="{'background-color': model}" style="width: 16px; height: 16px; display: inline-block"></i>
                           </span>
                </div>                       
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/colorpicker.js